import type { MouseEvent, PointerEvent } from 'react'

/** Prevent focused text fields from blurring before click completes (iOS mobile web). */
export function keepClickOnTouch(e: MouseEvent | PointerEvent) {
  const active = document.activeElement
  if (!(active instanceof HTMLInputElement || active instanceof HTMLTextAreaElement)) return
  if (active === e.currentTarget) return
  e.preventDefault()
}
